<!-- eslint-disable -->
<template lang="pug">
    transition(
        name="pull-out",
        @enter="enter",
        @after-enter="afterEnter",
        @leave="leave"
    )
        slot
</template>

<script>
    /*eslint-disable*/
    export default {
        methods: {
            enter (element) {
                const width = getComputedStyle(element).width

                element.style.width = width
                element.style.position = 'absolute'
                element.style.visibility = 'hidden'
                element.style.height = 'auto'

                const height = getComputedStyle(element).height

                element.style.width = null
                element.style.position = null
                element.style.visibility = null
                element.style.height = 0

                // Force repaint to make sure the
                // animation is triggered correctly.

                getComputedStyle(element).height

                // Trigger the animation.
                // We use `setTimeout` because we need
                // to make sure the browser has finished
                // painting after setting the `height`
                // to `0` in the line above.

                setTimeout(() => {
                    element.style.height = height
                })
            },
            afterEnter (element) {
                element.style.height = 'auto'
            },
            leave (element) {
                const height = getComputedStyle(element).height

                element.style.height = height

                // Force repaint to make sure the
                // animation is triggered correctly.

                getComputedStyle(element).height

                setTimeout(() => {
                    element.style.height = 0
                })
            }
        }
    }
</script>

<style scoped>
    * {
        will-change: height;
        transform: translateZ(0);
        backface-visibility: hidden;
        perspective: 1000px;
    }


    .pull-out-enter, .pull-out-leave-to {
        height: 0;
        opacity: 0;
    }

    .pull-out-enter-active, .pull-out-leave-active {
        transition: all .8s ease;
        overflow: hidden;
    }
</style>
